import { render, staticRenderFns } from "./Ligne.vue?vue&type=template&id=15544860&scoped=true&"
import script from "./Ligne.vue?vue&type=script&lang=ts&"
export * from "./Ligne.vue?vue&type=script&lang=ts&"
import style0 from "./Ligne.vue?vue&type=style&index=0&id=15544860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15544860",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout,VRow})
